<template>
  <div>
    <div v-if="!isMobile"></div>
    <div v-else>
      <div class="header mobileHeader">
        <div class="avatarFrame">
          <div
            class="avatarMobile"
            :style="{ 'background-image': ImageUrl }"
            @click="$router.push('/change-picture-request')"
          ></div>
        </div>
        <div class="nameMobile">
          <div style="font-size: 13px">{{ fullName }}</div>
        </div>
        <div class="selectRoleParent">
          <app-select-role />
        </div>
        <v-btn
          class="login-button"
          color="red white--text"
          @click="handleLogin"
          rounded
          >خروج
          <v-icon right> mdi-power </v-icon>
        </v-btn>
      </div>

      <div class="menus">
        <v-row align="center" style="margin: 0 !important">
          <v-col
            align="center"
            v-for="(item, index) in menuDetails"
            :key="index"
            cols="4"
            sm="3"
            lg="2"
            class="menuCol"
          >
            <v-btn class="btn-menus" @click="goToRoute(item.route)">
              <div>
                <font-awesome-icon
                  :icon="item.icon"
                  class="menuIcon"
                  size="2x"
                  :color="item.color"
                />
              </div>
              <span class="menuTitle" :style="[{ color: '#5c5c5c' }]">{{
                item.title
              }}</span>
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
    <app-no-branch v-if="noBranch" />
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
import MobileRow from "@/components/MobileRow";
import { logout } from "@/utils/auth";
import selectRole from "@/components/SelectRole";
import NoBranch from "@/components/NoBranch";
export default {
  components: {
    appRow: DetailRow,
    appMobileRow: MobileRow,
    appSelectRole: selectRole,
    appNoBranch: NoBranch,
  },
  data() {
    return {
      selectedMenu: 0,
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isReporter() {
      return this.$store.getters.isReporter;
    },
    isModir() {
      return this.$store.getters.isModir;
    },
    isHesabdar() {
      return this.$store.getters.isHesabdar;
    },
    isAshpaz() {
      return this.$store.getters.isAshpaz;
    },
    isEnduser() {
      return this.$store.getters.isEnduser;
    },
    isModirAdmin() {
      return this.$store.getters.isModirAdmin;
    },
    currentBranch() {
      return this.$store.getters.currentBranch;
    },
    fullName() {
      return this.$store.getters.FullName;
    },
    numSystem() {
      return this.$store.getters.NumSystem;
    },

    ImageUrl() {
      if (this.$store.getters.ImageUrl != "") {
        return "url(" + this.$store.getters.ImageUrl + ")";
      } else return "../assets/avatar.jpg";
    },

    isMobile() {
      return this.$store.getters.isMobile;
    },

    NumSystem() {
      var num = this.$store.getters.NumSystem;
      return num != "" ? "کد طلبگی:  " + num : "";
    },

    menuOptions() {
      return this.$store.getters.menuOptions.slice(1);
    },
    menuHeaders() {
      return this.menuOptions.filter((single) => {
        return single.route == undefined;
      });
    },
    menuDetails() {
      var result = [];
      for (let i = 0; i < this.menuOptions.length; i++) {
        const option = this.menuOptions[i];
        if (
          (option.isAdmin && this.isAdmin && !this.currentBranch) ||
          (option.isModirAdmin && this.isModirAdmin) ||
          (option.isReporter && this.isReporter) ||
          (option.isModir && this.isModir) ||
          (option.isHesabdar && this.isHesabdar) ||
          (option.isAshpaz && this.isAshpaz) ||
          (option.isEnduser && this.isEnduser)
        ) {
          result.push(option);
        }
      }
      return result;
    },
    noBranch() {
      const ub = [
        ...this.$store.getters.branches,
        ...this.$store.getters.permissions,
      ];
      return ub.length <= 0;
    },
  },

  methods: {
    handleLogin() {
      logout();
    },
    goToRoute(route) {
      this.$store.commit("RESET_SELECTED_FARD");
      window.scrollTo(0, 0);
      if (route.search("/") == 0) {
        this.$router.push(route);
      } else {
        window.open(route);
      }
    },
  },
};
</script>
<style scoped>
.fullname {
  padding-bottom: 30px;
}

.avatarMobile {
  width: 70px;
  height: 70px;
  border-radius: 35px;
  background-size: cover;
  margin: auto;
  top: 4px;
  position: relative;
  background-position: 50%;
  cursor: pointer;
}

.avatarFrame {
  width: 80px;
  height: 80px;
  border-radius: 340px;
  margin: auto;
  top: 60px;
  position: relative;
  border: 2px dotted rgba(255, 255, 255, 0.6);
}

.textinfo {
  padding: 35px 10px;
}

.addressButton {
  width: unset;
  margin-top: 50px;
  text-align: center;
  font-weight: bold;
  font-size: 18px;
}

.header {
  top: 0;
  position: fixed;
  width: 100%;
  z-index: 2;
  padding-bottom: 5px;
  height: 225px;
  text-align: center;
}

.nameMobile {
  color: white;

  font-size: 1em;
  top: 65px;
  position: relative;
}
.login-button {
  position: fixed;
  top: 70px;
  left: 5px;
  border-radius: 4px;
  font-size: 10px;
  width: 48px !important;
  min-width: unset !important;

  height: 24px !important;
  padding: 0 8px !important;
}

.v-btn-toggle {
  width: 100%;
  position: fixed;
  bottom: 0;
}

.v-btn-toggle .v-btn {
  width: 33.33%;
  margin: 0 !important;
}

.menus {
  position: relative;

  padding-bottom: 70px;
  top: 165px;
  min-height: calc(100vh - 250px);
}

.tabIcon {
  margin-right: 10px;
}
.metaData {
  font-size: 13px;
  top: 15px;
  position: relative;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  padding-bottom: 4px;
}

.d-flex {
  padding: 6px 12px;
}

.mobileHeader {
  background: url("../../assets/pattern.jpg") repeat-x;
}

.v-icon {
  margin: 0 !important;
  font-size: 16px;
}

.v-item--active {
  background: rgb(33, 118, 208) !important;
  background: linear-gradient(
    180deg,
    rgba(33, 118, 208, 1) 0%,
    rgba(33, 118, 208, 1) 35%,
    rgba(12, 50, 91, 1) 100%
  ) !important;
  color: white !important;
}
.v-btn-toggle > .v-btn {
  border-radius: 0 !important;
}

.selectRoleParent {
  position: fixed;
  left: 10px;
  top: 0px;
}
</style>

